import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const TradingHistory = () => {
  const [activeTab, setActiveTab] = useState('recent');

  const recentTrades = [
    {
      id: 1,
      type: 'buy',
      crypto: 'BTC',
      amount: 0.5234,
      price: 42150,
      total: 22067.31,
      time: '2026-01-12 16:45:23',
      status: 'completed'
    },
    {
      id: 2,
      type: 'sell',
      crypto: 'ETH',
      amount: 2.4567,
      price: 2280,
      total: 5601.28,
      time: '2026-01-12 15:30:15',
      status: 'completed'
    },
    {
      id: 3,
      type: 'buy',
      crypto: 'BNB',
      amount: 15.7890,
      price: 312,
      total: 4926.17,
      time: '2026-01-12 14:20:45',
      status: 'completed'
    },
    {
      id: 4,
      type: 'buy',
      crypto: 'SOL',
      amount: 45.2341,
      price: 98,
      total: 4432.94,
      time: '2026-01-12 13:15:30',
      status: 'completed'
    },
    {
      id: 5,
      type: 'sell',
      crypto: 'ADA',
      amount: 1250.5678,
      price: 0.52,
      total: 650.30,
      time: '2026-01-12 12:05:18',
      status: 'completed'
    }
  ];

  const openOrders = [
    {
      id: 1,
      type: 'buy',
      crypto: 'BTC',
      amount: 0.2500,
      price: 41500,
      total: 10375.00,
      time: '2026-01-12 16:50:00',
      status: 'pending',
      filled: 0
    },
    {
      id: 2,
      type: 'sell',
      crypto: 'ETH',
      amount: 1.5000,
      price: 2350,
      total: 3525.00,
      time: '2026-01-12 16:30:00',
      status: 'pending',
      filled: 35
    }
  ];

  const tabs = [
    { id: 'recent', label: 'Recent Trades', icon: 'History' },
    { id: 'open', label: 'Open Orders', icon: 'Clock' }
  ];

  const TradeRow = ({ trade, isOpenOrder }) => (
    <div className="grid grid-cols-2 md:grid-cols-7 gap-2 md:gap-4 px-4 py-3 hover:bg-muted/50 transition-colors border-b border-border last:border-b-0">
      <div className="flex items-center gap-2">
        <div className={`w-2 h-2 rounded-full ${trade?.type === 'buy' ? 'bg-success' : 'bg-error'}`} />
        <span className={`text-xs md:text-sm font-medium ${trade?.type === 'buy' ? 'text-success' : 'text-error'}`}>
          {trade?.type?.toUpperCase()}
        </span>
      </div>
      
      <div className="text-right md:text-left">
        <span className="text-xs md:text-sm font-semibold text-foreground">{trade?.crypto}</span>
      </div>
      
      <div className="text-xs md:text-sm text-foreground">
        {trade?.amount?.toFixed(4)}
      </div>
      
      <div className="text-right md:text-left text-xs md:text-sm text-foreground">
        ${trade?.price?.toLocaleString()}
      </div>
      
      <div className="text-xs md:text-sm font-medium text-foreground">
        ${trade?.total?.toLocaleString()}
      </div>
      
      <div className="text-xs text-muted-foreground hidden md:block">
        {new Date(trade.time)?.toLocaleString()}
      </div>
      
      <div className="flex items-center justify-end gap-2">
        {isOpenOrder ? (
          <>
            <div className="flex items-center gap-1">
              <div className="w-16 h-1.5 bg-muted rounded-full overflow-hidden">
                <div 
                  className="h-full bg-primary transition-all duration-300"
                  style={{ width: `${trade?.filled}%` }}
                />
              </div>
              <span className="text-xs text-muted-foreground">{trade?.filled}%</span>
            </div>
            <button
              className="text-error hover:text-error/80 transition-colors"
              aria-label="Cancel order"
            >
              <Icon name="X" size={16} />
            </button>
          </>
        ) : (
          <span className={`text-xs px-2 py-1 rounded-full ${
            trade?.status === 'completed' 
              ? 'bg-success/10 text-success' :'bg-warning/10 text-warning'
          }`}>
            {trade?.status}
          </span>
        )}
      </div>
    </div>
  );

  return (
    <div className="bg-card rounded-lg border border-border">
      <div className="flex items-center border-b border-border overflow-x-auto">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex items-center gap-2 px-4 md:px-6 py-3 md:py-4 text-sm md:text-base font-medium transition-colors whitespace-nowrap ${
              activeTab === tab?.id
                ? 'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon name={tab?.icon} size={18} />
            <span>{tab?.label}</span>
            {tab?.id === 'open' && openOrders?.length > 0 && (
              <span className="ml-1 px-2 py-0.5 text-xs bg-primary text-primary-foreground rounded-full">
                {openOrders?.length}
              </span>
            )}
          </button>
        ))}
      </div>
      <div className="hidden md:grid grid-cols-7 gap-4 px-4 py-3 text-xs font-medium text-muted-foreground border-b border-border">
        <span>Type</span>
        <span>Pair</span>
        <span>Amount</span>
        <span>Price</span>
        <span>Total</span>
        <span>Time</span>
        <span className="text-right">Status</span>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {activeTab === 'recent' ? (
          recentTrades?.length > 0 ? (
            recentTrades?.map((trade) => (
              <TradeRow key={trade?.id} trade={trade} isOpenOrder={false} />
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-12">
              <Icon name="History" size={48} color="var(--color-muted-foreground)" />
              <p className="text-sm text-muted-foreground mt-3">No recent trades</p>
            </div>
          )
        ) : (
          openOrders?.length > 0 ? (
            openOrders?.map((order) => (
              <TradeRow key={order?.id} trade={order} isOpenOrder={true} />
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-12">
              <Icon name="Clock" size={48} color="var(--color-muted-foreground)" />
              <p className="text-sm text-muted-foreground mt-3">No open orders</p>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default TradingHistory;